<template>
  <section id="scout" class="section">
    <div class="section__content">
      <div class="wrap">
        <div data-aos="fade-up">
          <div
            class="section__title-img"
            data-aos="fade-up"
            data-aos-delay="800"
          ></div>
          <div class="section__title" data-aos="fade-up">
            <span class="span-1 section__span--purple"
              >美股強勢看漲
              <div class="shrink">，</div>
              該怎麼佈局
              <div class="shrink">？</div></span
            >
            <br />
            <span class="span-2 section__span--bold section__span--purple"
              >緊跟專業團隊
              <div class="comma">，</div></span
            ><br class="inactive" />
            <span class="span-3 section__span--bold section__span--purple"
              >躍進最佳得分選手
              <div class="shrink">！</div></span
            >
          </div>
        </div>

        <div class="table-box table-box--purple" data-aos="fade-up">
          <div class="tabs">
            <div
              v-for="(tab, index) in tabs"
              :key="index"
              @click="activeTab = index"
              :class="{ active: activeTab === index }"
              :style="{
                backgroundImage: `url(${
                  isSmallScreen ? tab.name : tab.namePC
                })`,
              }"
              class="tabs__list"
            >
              <img
                v-if="activeTab === index"
                :src="isSmallScreen ? tab.active : tab.activePC"
                class="active-indicator"
                alt=""
              />
            </div>
          </div>

          <div class="tab-content">
            <transition name="fade">
              <div
                v-show="activeTab === 0"
                class="tab-content__item"
                :class="{ active: activeTab === 0 }"
              >
                <div class="tab-content__title">找出優勢成長DNA</div>
                <div class="tab-content__discript">
                  <p>
                    本基金專注於挑選具「特殊競爭優勢」之大型成長股，<br />
                    如：寡占商業模式、創新產品、品牌優勢…等。
                    <!-- 「成長股」為營收具快速成長潛力的企業，本基金<br
                      class="inactive--opposite"
                    />專注於<br
                      class="inactive--block"
                    />挑選具「特殊競爭優勢」之大型股，例如：寡佔商業模式、<br
                      class="inactive"
                    />創新產品、品牌優勢。 -->
                  </p>
                </div>
                <div class="tab-content__chart chart">
                  <img src="../assets/images/s2_chart-1.png" alt="" />
                </div>
                <div class="secure-text">
                  資料來源：Bloomberg(含預估值)、各企業官網及年報，中國信託投信整理，截至2025Q2。
                  <span class="highlight">
                    若內容涉及個股、類股或產業，僅為參考舉例，不代表個股、類股或產業推薦，且不為未來投資獲利之保證，亦不一定為基金未來之持股。投資人申購本基金係持有基金受益憑證，而非本文提及之投資資產或標的。</span
                  >
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-show="activeTab === 1"
                class="tab-content__item"
                :class="{ active: activeTab === 1 }"
              >
                <div class="tab-content__title">
                  「兩高一低」價值策略<br class="inactive" />七步驟落實
                </div>
                <div class="tab-content__discript">
                  <!-- <p>
                    精心挑選高成長、高品質且低估值的股票，<br
                      class="inactive"
                    />搭配獨特的選股法與獲利引擎，
                  </p>
                  <p>為你開創長期超額報酬的機會。</p> -->
                </div>
                <div class="tab-content__chart chart">
                  <img src="../assets/images/s2_chart-2.png" alt="" />
                </div>
                <div class="secure-text">
                  資料來源：法盛投資管理，中國信託投信整理。<span
                    class="highlight"
                    >以上僅為本基金選股策略，不代表未來績效保證，不同時間進行操作，其結果亦可能不同。</span
                  >
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-show="activeTab === 2"
                class="tab-content__item"
                :class="{ active: activeTab === 2 }"
              >
                <div class="tab-content__title">
                  持續投資，掌握長期潛在<br class="inactive" />大波段漲幅
                </div>
                <!-- <div class="tab-content__discript">
                  <p>本基金長期持有至今之個股 (舉例)</p>
                </div> -->
                <div class="tab-content__chart chart">
                  <!-- <div class="tab-content__chart-text">
                    本基金長期持有至今之個股 (舉例)
                  </div> -->
                  <img src="../assets/images/s2_chart-3.png" alt="" />
                </div>
                <div class="secure-text">
                  資料來源：Bloomberg，法盛投資管理，中國信託投信整理，資料時間：2016/6/8(本基金成立日)以來至2025/08，單位：％；本基金除輝達是於2019/1首次買進外，其餘個股均於基金成立日即買進並持有至今。
                  <span class="highlight"
                    >若內容涉及個股、類股或產業，僅為參考舉例，不代表個股、類股或產業推薦，且不為未來投資獲利之保證，亦不一定為基金未來之持股。投資人申購本基金係持有基金受益憑證，而非本文提及之投資資產或標的。
                  </span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'Scout',
  props: {},
  data: () => {
    return {
      activeTab: 0,
      // currentTab: 0,
      isSmallScreen: window.innerWidth <= 1080,
      tabs: [
        {
          name: require('../assets/images/s2_tab1_m.png'),
          active: require('../assets/images/s2_tab1_active_m.png'),
          namePC: require('../assets/images/s2_tab1.png'),
          activePC: require('../assets/images/s2_tab1_active.png'),
        },
        {
          name: require('../assets/images/s2_tab2_m.png'),
          active: require('../assets/images/s2_tab2_active_m.png'),
          namePC: require('../assets/images/s2_tab2.png'),
          activePC: require('../assets/images/s2_tab2_active.png'),
        },
        {
          name: require('../assets/images/s2_tab3_m.png'),
          active: require('../assets/images/s2_tab3_active_m.png'),
          namePC: require('../assets/images/s2_tab3.png'),
          activePC: require('../assets/images/s2_tab3_active.png'),
        },
      ],
    };
  },
  computed: {
    // ...mapState([])
  },
  methods: {
    // ...mapActions([]),
    updateScreenType() {
      this.isSmallScreen = window.innerWidth <= 1080;
    },
    beforeEnter(el) {
      // 在新內容進入前，設定 currentTab 為 activeTab
      this.currentTab = this.activeTab;
    },
    afterLeave(el) {
      // 在舊內容完全離開後，顯示新內容
      this.currentTab = this.activeTab;
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateScreenType);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenType);
  },
  components: {},
};
</script>

<style lang="scss">
$assets: '~@/assets/images/scout/';

#scout {
  width: 100%;
  max-width: 1920px;
  // height: 1570px;
  background-image: url('../assets/images/s2_bg.jpg');
  background-repeat: repeat-y;
  background-size: 1920px 1570px;
  background-position: center top;
  z-index: 1;
  padding: calc(124px * 0.8) 0 calc(203px * 0.8) 0;
  @include tabletX {
    background-size: vwX(1920) vwX(1570);
    padding: calc(vwX(124) * 0.8) 0 calc(vwX(203) * 0.8) 0;
  }
  @include tablet {
    width: 100%;
    background-image: url('../assets/images/s2_bg_m.jpg');
    background-size: 100% auto;
    padding: vwM(172) 0 vwM(270) 0;
  }

  .section__content {
    .section__title-img {
      width: 763px;
      height: 690px;
      background-image: url('../assets/images/s2_titile_img.png');
      background-size: 763px 690px;
      top: -272px;
      left:610px;
      @include tabletX {
        width: vwX(763);
        height: vwX(690);
        background-size: vwX(763) vwX(690);
        top: vwX(-272);
        left: vwX(610);
      }
      @include tablet {
        width: vwM(891);
        height: vwM(806);
        background-size: vwM(891) vwM(806);
        top: vwM(-420);
        left: vwM(114);
        z-index: 2;
      }
    }

    .section__title {
      .shrink {
        display: inline-block;
        margin: 0 -22px;
        @include tabletX {
          margin: 0 vwX(-22);
        }
        @include tablet {
          margin: 0 vwX(-30);
        }
      }
      .span-3 {
        padding-left: 0;
        margin-left: -23px;
        @include tablet {
          padding-left: vwM(58);
          margin-left: 0;
        }
      }
    }

    .table-box {
      &.table-box--purple {
        border-bottom: 20px solid #64117d;
        margin-top: 18px;
        padding: 0;
        @include tablet {
          border-bottom: vwM(20) solid #64117d;
          margin-top: vwM(18);
        }
      }
    }

    .tabs {
      background-color: #efe7f2;
    }

    .tabs__list {
      width: 431px;
      height: 209px;
      background-size: cover;
      background-position: center top;
      background-repeat: no-repeat;
      @include tabletX {
        width: vwX(431);
        height: vwX(209);
      }
      @include tablet {
        width: vwM(318);
        height: vwM(285);
      }
      .active-indicator {
        width: 435px;
        height: 270px;
        position: absolute;
        @include tabletX {
          width: vwX(435);
          height: vwX(270);
        }
        @include tablet {
          width: vwM(349);
          height: vwM(321);
        }
      }
      &:nth-child(1) .active-indicator {
        top: 0;
        left: 50px;
        @include tabletX {
          left: vwX(50);
        }
        @include tablet {
          left: 0;
        }
      }
      &:nth-child(2) .active-indicator {
        top: 0;
        left: calc(50% - 217px);
        @include tabletX {
          left: calc(50% - vwX(217));
        }
        @include tablet {
          left: calc(50% - vwM(174));
        }
      }
      &:nth-child(3) .active-indicator {
        top: 0;
        right: 50px;
        @include tabletX {
          right: vwX(50);
        }
        @include tablet {
          right: 0;
        }
      }
    }

    .tab-content {
      .tab-content__title {
        color: #64117d;
      }
      .tab-content__item {
        position: absolute;
        top: 33%;
        left: 3.2%;
        width: 100%;
        opacity: 0;
        transition: opacity 0s ease;
        &.active {
          position: relative;
          top: unset;
          left: unset;
          opacity: 1;
        }
      }
      .tab-content__item:nth-child(1) {
        .tab-content__chart {
          img {
            width: 1105px;
            // height: 453px;
            @include tabletX {
              width: vwX(1105);
              // height: vwX(453);
            }
            @include tablet {
              width: vwM(885);
              // height: vwM(363);
            }
          }
        }
      }
      .tab-content__item:nth-child(2) {
        .tab-content__title {
          margin-top: 20px;
          margin-bottom: 55px;
          @include tablet {
            margin-top: 0;
            margin-bottom: 0;
          }
        }
        .tab-content__chart {
          img {
            width: 1105px;
            // height: 394px;
            @include tabletX {
              width: vwX(1105);
              // height: vwX(394);
            }
            @include tablet {
              // width: vwM(1549);
              // height: vwM(553);
              width: vwM(885);
            }
          }
        }
      }
      .tab-content__item:nth-child(3) {
        .tab-content__chart {
          padding-top: 10px;
          @include tabletX {
            padding-top: vwX(10);
          }
        }
        .tab-content__discript {
          @include tablet {
            display: none;
          }
        }
        .tab-content__chart {
          .tab-content__chart-text {
            display: none;
            @include tablet {
              display: block;
              letter-spacing: letterSpacing(120, vwM(22));
              top: vwM(55);
              left: 22.5%;
            }
          }
          img {
            width: 1105px;
            height: 531px;
            @include tabletX {
              width: vwX(1105);
              height: vwX(531);
            }
            @include tablet {
              // width: vwM(1570);
              // height: vwM(755);
              width: vwM(885);
              padding-top: vwM(10);
            }
          }
        }
      }
      .tab-content__chart {
        padding-top: 50px;
        margin-left: 0;
        @include tabletX {
          padding-top: vwX(50);
        }
        @include tablet {
          padding-top: vwM(20);
        }
      }

      .secure-text {
        width: 1200px;
        margin-top: 50px;
        color: #3f3f3f;
        @include tabletX {
          width: vwX(1200);
          margin-top: vwX(50);
        }
        @include tablet {
          width: vwM(840);
          margin-top: vwM(50);
        }
        .highlight {
          color: #64117d;
        }
      }
    }
  }
}
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.3s ease;
// }
// .fade-enter,
// .fade-leave-to {
//   opacity: 0;
//   // display: block; // 確保過渡期間元素保持可見
// }
</style>
